import React, { createContext, useState, useContext, useEffect } from 'react';
import { authService } from '../services/api';
import { Spin } from 'antd';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);
    const [permissions, setPermissions] = useState([]);

    useEffect(() => {
        const storedUser = localStorage.getItem('user');
        const token = localStorage.getItem('token');
        const storedPermissions = localStorage.getItem('permissions');

        if (storedUser && token) {
            try {
                setUser(JSON.parse(storedUser));
            } catch (e) {
                setUser(null);
            }
            if (storedPermissions) {
                try {
                    const parsed = JSON.parse(storedPermissions);
                    setPermissions(Array.isArray(parsed) ? parsed : []);
                } catch (e) {
                    setPermissions([]);
                }
            } else {
                setPermissions([]);
            }
            setIsAuthenticated(true);
        }
        setLoading(false);
    }, []);

    const login = async (username, password) => {
        try {
            const response = await authService.login(username, password);
            if (response.status === 'success') {
                const { user, token, permissions } = response.data;
                localStorage.setItem('token', token);
                localStorage.setItem('user', JSON.stringify(user));
                localStorage.setItem('permissions', JSON.stringify(permissions));
                setUser(user);
                setPermissions(permissions || []);
                setIsAuthenticated(true);
                return true;
            }
        } catch (error) {
            console.error("Login failed", error);
            throw error;
        }
        return false;
    };

    const logout = (skipRedirect = false) => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('permissions');
        setUser(null);
        setPermissions([]);
        setIsAuthenticated(false);
        if (!skipRedirect) {
            window.location.href = '/login';
        }
    };

    if (loading) {
        return <div style={{ display: 'flex', justifyContent: 'center', marginTop: 100 }}><Spin size="large" /></div>;
    }

    const refreshSession = async () => {
        try {
            await authService.pingSession();
            return true;
        } catch (error) {
            console.error("Failed to refresh session", error);
            return false;
        }
    };

    return (
        <AuthContext.Provider value={{ user, permissions: Array.isArray(permissions) ? permissions : [], isAuthenticated, login, logout, refreshSession }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
